import { useSyncExternalStore } from 'react';

/**
 * The expenses deleted on screen whose `DELETE` is still waiting for its undo window (the board's
 * «Bozza eliminata · Annulla»), or already sent. The list leaves them out at once; «Annulla» or a
 * failed write brings them back. Module state, so it outlives the card that started the delete.
 */
let hidden: ReadonlySet<string> = new Set();
const listeners = new Set<() => void>();

function publish(next: ReadonlySet<string>) {
  hidden = next;
  for (const listener of listeners) listener();
}

export function hideExpense(id: string): void {
  if (hidden.has(id)) return;
  publish(new Set([...hidden, id]));
}

export function showExpense(id: string): void {
  if (!hidden.has(id)) return;
  const next = new Set(hidden);
  next.delete(id);
  publish(next);
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useHiddenExpenses(): ReadonlySet<string> {
  return useSyncExternalStore(subscribe, () => hidden);
}
